var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smart-wiring"},[_c('NavMenu',{on:{"on-switch-tabs":_vm.handleSwitchTabs}}),_c(_vm.activeComponent,{tag:"components"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }